const isValidLatLong = (latitude, longitude) => {
  if (isNaN(latitude) || isNaN(longitude)) return false;

  if (
    latitude < parseFloat(-90) ||
    latitude > parseFloat(90) ||
    longitude > parseFloat(180) ||
    longitude < parseFloat(-180)
  )
    return false;

  return true;
};
export default isValidLatLong;
